// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"_2a107cf","pagination":"_a22a10b","activeDot":"_dfdc03d","inactiveDot":"_f81374c"};